module.exports = __webpack_public_path__ + "static/media/facebook_mobile.6f4ad000.svg";